import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { Box, Button, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Footer } from '~/components/footer/footer';
import { MAIN_CONTENT_WIDTH } from '~/components/shell/layout';
import { colors } from '~/theme';

export const WelcomeScreen = () => {
  const navigate = useNavigate();

  return (
    <Stack minHeight="100vh" px={3} py={6}>
      <Stack flexGrow={1} mx="auto" width="100%" maxWidth={MAIN_CONTENT_WIDTH} spacing={4} useFlexGap>
        <Stack flexGrow={1} alignItems="center" justifyContent="center" spacing={4} textAlign="center">
          <Box component="img" src="/logo-validador.png" alt="CUB Validador de Cobranças" sx={{ height: 90 }} />
          <Typography variant="body1" sx={{ color: colors.trueCobalt, maxWidth: 360 }}>
            A CUB te ajuda a validar se a sua cobrança por boleto ou Pix é{' '}
            <Box component="span" fontWeight={700}>
              verdadeira
            </Box>
            .
          </Typography>
          <Box width="100%" maxWidth={360}>
            <Button
              variant="contained"
              size="large"
              fullWidth
              endIcon={<ChevronRightRoundedIcon />}
              onClick={() => navigate('/onboarding')}
            >
              VAMOS LÁ!
            </Button>
          </Box>
        </Stack>
        <Footer showLegalDisclaimer />
      </Stack>
    </Stack>
  );
};
